// calendly.js
// Function to load the Calendly widget
function loadCalendlyPopup(e) {
  e.preventDefault(); // Prevent default button behavior
  // Load the Calendly script dynamically
  const link = document.createElement('link');
  link.href = "https://assets.calendly.com/assets/external/widget.css";
  link.rel = "stylesheet";
  document.head.appendChild(link);
  const script = document.createElement('script');
  script.src = 'https://assets.calendly.com/assets/external/widget.js';
  script.async = true;
  document.head.appendChild(script);

  // Open the Calendly popup when the script is loaded
  script.onload = () => {
    // Ensure .calendly-close-overlay and .calendly-popup-close have display: block
    const style = document.createElement('style');
    style.textContent = `
      .calendly-close-overlay { display: block !important; }
      .calendly-popup-close { display: block !important; }
    `;
    document.head.appendChild(style);

    Calendly.initPopupWidget({ url: 'https://calendly.com/serpentandtheswan/design-consultation' });
    return false;
  };
}

// Attach the function to a button click
document.querySelector('[data-calendly-toggle]').addEventListener('click', (e) => loadCalendlyPopup(e));